module.exports = __webpack_public_path__ + "img/display_runeke_konsult.2ce177c6.png";